import { Provider } from '@angular/core';
import { Store } from '@ngrx/store';

import { extractValueFromStore } from '@ninety/platform/services/state-util';
import { FISCAL_CALENDAR_PROVIDER, FiscalCalendarProvider } from '@ninety/ui/core';
import { selectFiscalCalendar } from '@ninety/ui/legacy/core/calendar/state/fiscal-calendar.selectors';

/**
 * Binds {@link FISCAL_CALENDAR_PROVIDER} (consumed by `RocksQuarterMenuComponent` in `@ninety/ui/core`)
 * to a snapshot read of the `selectFiscalCalendar` selector — the same `extractValueFromStore` call the
 * component used to make itself. The component stays free of `@ngrx/store` so it can live in the
 * buildable public API; this composition-root wiring is the single place that depends on both the token
 * and the store. (DEV-26530 part 14)
 */
export const ROCKS_QUARTER_MENU_PROVIDERS: Provider[] = [
  {
    provide: FISCAL_CALENDAR_PROVIDER,
    useFactory:
      (store: Store): FiscalCalendarProvider =>
      () =>
        extractValueFromStore(store, selectFiscalCalendar),
    deps: [Store],
  },
];
